import { render } from "./LiveRoom.vue?vue&type=template&id=78bc4a3b&scoped=true"
import script from "./LiveRoom.vue?vue&type=script&lang=js"
export * from "./LiveRoom.vue?vue&type=script&lang=js"

import "./LiveRoom.vue?vue&type=style&index=0&id=78bc4a3b&scoped=true&lang=stylus"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bc4a3b"]])

export default __exports__